import React, { useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';
import { Card, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography, Button, TableContainer, Table, TableHead, TableRow, Paper, TableCell, TableBody, Divider, Box } from '@mui/material';

const colors = {
    darkGreen: '#06362D',
    calPolyGreen: '#155332',
    vanilla: '#DEE2B1',
    gold: '#FFD500',
    goldenrod: '#D1A505'
};

const animationStyles = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(15px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .page-fade-in {
    animation: fadeIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  /* --- METICULOUS PRINT STYLES --- */
  @media print {
    @page {
        size: A4;
        margin: 0mm;
    }

    html, body, #root {
        background: #fff !important;
        margin-left: -80px !important;
        padding: 0 !important;
        width: 1600px !important;
        color: #000 !important;
    }

    .no-print, nav, header, footer, .sidebar, button, .MuiTextField-root, .MuiFormControl-root {
        display: none !important;
    }

    * {
        color: #000 !important;
        background: transparent !important;
        box-shadow: none !important;
        text-shadow: none !important;
        animation: none !important;
        border-color: #ccc !important;
    }

    .page-fade-in {
        padding: 0 !important;
        margin: 0 !important;
        max-width: 100% !important;
        width: 100% !important;
    }

    .print-area {
        border: none !important;
        background: #fff !important;
        margin: 0 !important;
        padding: 0 !important;
        width: 100% !important;
    }

    table {
        width: 100% !important;
        border-collapse: collapse !important;
    }
    
    th, td {
        border: 1px solid #ddd !important;
        padding: 6px 8px !important;
        color: #000 !important;
    }

    th {
        background-color: #f5f5f5 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        font-weight: bold !important;
    }
  }
`;

function Receptionistreport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: colors.calPolyGreen,
        color: colors.vanilla,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    
    // Set default values to today's date
    const [fromDate, setfromDate] = useState(moment().format('YYYY-MM-DD'));
    const [toDate, settoDate] = useState(moment().format('YYYY-MM-DD'));

    const [receptId, setreceptId] = useState("");
    const [username, setusername] = useState("");
    const [bookingData, setbookingData] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [serviceData, setserviceData] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [recepts, setrecepts] = useState([]);
    const [total, settotal] = useState(0);
    const [propertyId, setPropertyId] = useState("");

    useEffect(() => {
        const unsub = auth.onAuthStateChanged(async (user) => {
            if (!user) return;

            setUserData(user);

            const roleSnap = await getDoc(doc(db, "authroles", user.uid));
            if (roleSnap.exists()) {
                setPropertyId(roleSnap.data().propertyId);
            }
        });

        return () => unsub();
    }, []);

    useEffect(() => {
        if (!propertyId) return;

        const q = query(
            collection(db, "authroles"),
            where("propertyId", "==", propertyId),
            where("role", "==", "Reception")
        );

        const unsub = onSnapshot(q, (querySnapshot) => {
            const list = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                data: doc.data()
            }));
            setrecepts(list);
            // Default to first receptionist if available and none selected
            if (list.length > 0 && !receptId) {
                setreceptId(list[0].data.uid);
                setusername(list[0].data.name);
            }
        });

        return () => unsub();
    }, [propertyId]);

    // Auto trigger report when receptionist or dates change
    useEffect(() => {
        if (propertyId && receptId && fromDate && toDate) {
            getReport();
        }
    }, [propertyId, receptId]);

    const getReport = async () => {
        if (!fromDate || !toDate || !receptId) {
            Toast.fire({ icon: "error", title: 'Please select Receptionist & Dates' });
            return;
        }

        if (!propertyId) {
            Toast.fire({ icon: "error", title: "Property not assigned" });
            return;
        }

        setloading(true);
        setbookingData([]);
        setpaymodes([]);
        setpayhistory([]);

        const startOfDay = new Date(fromDate);
        startOfDay.setHours(0, 0, 0, 0);
        const endOfDay = new Date(toDate);
        endOfDay.setDate(endOfDay.getDate() + 1);

        const reportDate = moment(fromDate).format('YYYY-MM-DD');

        try {
            const [payHistorySnapshot, serviucesSnapshot] = await Promise.all([
                getDocs(
                    query(
                        collection(db, "payhistory"),
                        where("propertyId", "==", propertyId),
                        where("uid", "==", receptId),
                        where("paymenttype", "==", "B"),
                        where("status", "==", "Working"),
                        where("createdAt", ">=", startOfDay),
                        where("createdAt", "<", endOfDay)
                    )
                ),
                getDocs(
                    query(
                        collection(db, "bookingservices"),
                        where("propertyId", "==", propertyId),
                        where("uid", "==", receptId),
                        where("type", "==", "Booking"),
                        where("createdAt", ">=", startOfDay),
                        where("createdAt", "<", endOfDay)
                    )
                )
            ]);

            const payHistoryDataPromises = payHistorySnapshot.docs.map(async (doc1) => {
                const docData = doc1.data();
                const [paymode1Snap, paymode2Snap, bookingSnap] = await Promise.all([
                    getDoc(doc(db, "paymentmodes", docData.paymode1)),
                    getDoc(doc(db, "paymentmodes", docData.paymode2)),
                    getDoc(doc(db, "reservations", docData.bookingid))
                ]);

                const paymode1 = paymode1Snap.exists() ? paymode1Snap.data().paymode : "";
                const paymode2 = paymode2Snap.exists() ? paymode2Snap.data().paymode : "";
                const date = docData.createdAt.toDate();
                const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;

                let bookingData = {};
                if (bookingSnap.exists()) {
                    const bookingDocData = bookingSnap.data();
                    bookingData = {
                        rooms: bookingDocData.rooms || [],
                        checkinDate: bookingDocData.checkindate ? bookingDocData.checkindate : null,
                        checkoutDate: bookingDocData.checkoutdate ? bookingDocData.checkoutdate : null,
                        custName: bookingDocData.customers && bookingDocData.customers.custname ? bookingDocData.customers.custname : ""
                    };
                }

                return {
                    id: doc1.id,
                    data: docData,
                    paymode1,
                    paymode2,
                    createdat: formattedDate,
                    bookingData
                };
            });
            const payHistoryData = await Promise.all(payHistoryDataPromises);
            setpayhistory(payHistoryData);

            const serviceData = serviucesSnapshot.docs.map((doc) => {
                const data = doc.data();
                const createdAt = data.createdAt;
                const entryTime = createdAt ? createdAt.toDate() : null;
                const entryTimeFomat = moment(entryTime).format('DD-MM-YYYY hh:mm:ss A');

                return {
                    id: doc.id,
                    data: data,
                    entryTime: entryTimeFomat,
                };
            });
            setserviceData(serviceData);

            const paymentModesSnapshot = await getDocs(collection(db, "paymentmodes"));
            const paymentModeIds = paymentModesSnapshot.docs.map((doc) => doc.id);

            const totalAmountPromises = paymentModeIds.map(async (paymodeId) => {
                const [paymode1TotalSnapshot, paymode2TotalSnapshot] = await Promise.all([
                    getDocs(
                        query(
                            collection(db, "payhistory"),
                            where("paymode1", "==", paymodeId),
                            where("createdAt", ">=", startOfDay),
                            where("uid", "==", receptId),
                            where("createdAt", "<", endOfDay),
                            where("paymenttype", "==", "B"),
                            where("status", "==", "Working"),
                            where("propertyId", "==", propertyId),
                        )
                    ),
                    getDocs(
                        query(
                            collection(db, "payhistory"),
                            where("paymode2", "==", paymodeId),
                            where("createdAt", ">=", startOfDay),
                            where("uid", "==", receptId),
                            where("createdAt", "<", endOfDay),
                            where("paymenttype", "==", "B"),
                            where("status", "==", "Working"),
                            where("propertyId", "==", propertyId),
                        )
                    )
                ]);

                const total1 = paymode1TotalSnapshot.docs.reduce((sum, doc) => sum + (doc.data().amount1 || 0), 0);
                const total2 = paymode2TotalSnapshot.docs.reduce((sum, doc) => sum + (doc.data().amount2 || 0), 0);

                const paymode = paymentModesSnapshot.docs.find(doc => doc.id === paymodeId)?.data().paymode || "";

                return {
                    id: paymodeId,
                    paymode,
                    totalamount: (total1 + total2).toFixed(2)
                };
            });

            const paymentData = await Promise.all(totalAmountPromises);
            setpaymodes(paymentData);

            const totalAmount = paymentData.reduce((sum, data) => sum + parseFloat(data.totalamount), 0);
            settotal(totalAmount.toFixed(0));

            const q1 = query(
                collection(db, 'payhistory'),
                where('status', '==', 'Working'),
                where('createdAt', '>=', Timestamp.fromDate(startOfDay)),
                where("uid", "==", receptId),
                where('createdAt', '<', Timestamp.fromDate(endOfDay)),
                where("propertyId", "==", propertyId),
            );

            const payhistorySnapshot = await getDocs(q1);
            const paymentHistoryData = await Promise.all(payhistorySnapshot.docs.map(async (doc1) => {
                const data = doc1.data();
                const [paymode1Snap, paymode2Snap] = await Promise.all([
                    getDoc(doc(db, "paymentmodes", data.paymode1)),
                    getDoc(doc(db, "paymentmodes", data.paymode2))
                ]);
                const paymode1 = paymode1Snap.exists() ? paymode1Snap.data().paymode : "";
                const paymode2 = paymode2Snap.exists() ? paymode2Snap.data().paymode : "";
                const date = data.createdAt.toDate();
                const createdat = moment(date).format('DD-MM-YYYY HH:mm:ss');

                return {
                    id: doc1.id,
                    data,
                    paymode1,
                    paymode2,
                    amount1: data.amount1 || 0,
                    amount2: data.amount2 || 0,
                    createdat
                };
            }));

            const checkinDetailsCheckoutQuery = query(
                collection(db, 'checkindetails'),
                where("uid", "==", receptId),
                where('status', '==', 'Checkout'),
                where('checkindate', '==', reportDate),
                where("propertyId", "==", propertyId),
            );

            const checkinDetailsBookedQuery = query(
                collection(db, 'checkindetails'),
                where("uid", "==", receptId),
                where('status', '==', 'Booked'),
                where('checkindate', '==', reportDate),
                where("propertyId", "==", propertyId),
            );

            const [checkinDetailsCheckoutSnapshot, checkinDetailsBookedSnapshot] = await Promise.all([
                getDocs(checkinDetailsBookedQuery),
                getDocs(checkinDetailsCheckoutQuery),
            ]);

            const checkinDetailsData = [
                ...checkinDetailsCheckoutSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })),
                ...checkinDetailsBookedSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            ];

            const uniqueCheckinDetails = Array.from(
                new Map(checkinDetailsData.map(item => [item.bookingid, item])).values()
            );

            const bookingIds = uniqueCheckinDetails.map(doc => doc.bookingid);
            if (bookingIds.length === 0) {
                setbookingData([]);
                setloading(false);
                return;
            }

            const bookingsQuery = query(
                collection(db, 'reservations'),
                where('__name__', 'in', bookingIds)
            );

            const bookingsSnapshot = await getDocs(bookingsQuery);
            const bookingsDataMap = bookingsSnapshot.docs.reduce((acc, doc) => {
                acc[doc.id] = { id: doc.id, ...doc.data() };
                return acc;
            }, {});

            const paymentHistoryMap = paymentHistoryData.reduce((acc, pay) => {
                const bookingId = pay.data.bookingid;
                if (bookingsDataMap[bookingId]) {
                    if (!acc[bookingId]) {
                        acc[bookingId] = [];
                    }
                    acc[bookingId].push(pay);
                }
                return acc;
            }, {});

            const combinedData = await Promise.all(uniqueCheckinDetails.map(async (checkinDetail) => {
                const bookingData = bookingsDataMap[checkinDetail.bookingid] || null;
                if (!bookingData) {
                    return null;
                }

                const roomamount = bookingData.rooamount || 0;
                const date1 = moment(bookingData.checkindate, 'YYYY-MM-DD');
                const date2 = moment(reportDate, 'YYYY-MM-DD');

                let dayDifference = date2.diff(date1, 'days');
                if (dayDifference === 0) {
                    dayDifference = 1;
                }

                const serviceamount = parseFloat(bookingData?.serviceamount) / parseFloat(bookingData.noofdays) || 0;

                const q = query(
                    collection(db, 'orders'),
                    where('status', '==', 'Bill Pending'),
                    where('orderdate', '==', reportDate),
                    where('bookingId', '==', checkinDetail.bookingid),
                    where("propertyId", "==", propertyId),
                );

                const querySnapshot = await getDocs(q);
                let foodTotal = 0;
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    foodTotal += data.totalamount || 0;
                });

                let paymentHistory = paymentHistoryMap[checkinDetail.bookingid] || [];
                let paidAmount = paymentHistory.reduce((sum, pay) => sum + pay.amount1 + pay.amount2, 0);

                let totalamount = parseFloat(roomamount) + parseFloat(serviceamount) + parseFloat(foodTotal);
                let alltoal = parseFloat(totalamount) * parseFloat(dayDifference);
                let remaining = parseFloat(alltoal) - parseFloat(paidAmount);

                return {
                    ...checkinDetail,
                    booking: bookingData,
                    serviceamount,
                    roomamount: roomamount.toFixed(0),
                    foodamount: foodTotal.toFixed(0),
                    totalamount: totalamount.toFixed(0),
                    alltoal: alltoal.toFixed(0),
                    paidamount: paidAmount.toFixed(0),
                    pending: remaining.toFixed(0),
                    todayDays: dayDifference,
                    paymentHistory
                };
            }));

            setbookingData(combinedData.filter(item => item !== null));
        } catch (error) {
            console.error(error);
            Toast.fire({ icon: "error", title: "Failed to fetch report" });
        } finally {
            setloading(false);
        }
    };

    const handlePrint = () => {
        window.print();
    };

    const handleFromDate = (e) => {
        setfromDate(e.target.value);
    }
    const handleToDate = (e) => {
        settoDate(e.target.value);
    }

    return (
        <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: colors.darkGreen, color: colors.vanilla, p: { xs: 2, md: 4 } }} className="page-fade-in">
            <style>{animationStyles}</style>
            <Box component="main" sx={{ flexGrow: 1, maxWidth: "1600px", margin: "0 auto", width: "100%" }}>
                <div style={{ backgroundColor: 'transparent' }}>
                    <section className="content mt-2">
                        <div className="container-fluid p-0">
                            <Typography
                                variant="h5"
                                fontWeight={800}
                                mb={3}
                                sx={{ color: colors.vanilla }}
                                className="no-print"
                            >
                                Receptionist Report
                            </Typography>

                            <div className="row">
                                <div className="col-md-12">
                                    <Card sx={{ borderRadius: 3, border: `1px solid ${colors.goldenrod}`, bgcolor: colors.calPolyGreen, color: colors.vanilla, boxShadow: "0 4px 20px 0 rgba(0,0,0,0.3)", mb: 4 }} className="no-print">
                                        <CardContent sx={{ p: 3 }}>
                                            <div className="container-fluid p-0">
                                                <div className="row align-items-center">
                                                    {/* Receptionist */}
                                                    <div className="col-sm-3 mb-3 mb-sm-0">
                                                        <FormControl fullWidth size="small">
                                                            <InputLabel sx={{ color: colors.vanilla }}>Select Receptionist</InputLabel>
                                                            <Select
                                                                value={receptId}
                                                                label="Select Receptionist"
                                                                onChange={(e) => {
                                                                    const selectedId = e.target.value;
                                                                    setreceptId(selectedId);
                                                                    const found = recepts.find(r => r.data.uid === selectedId);
                                                                    if (found) setusername(found.data.name);
                                                                }}
                                                                sx={{ 
                                                                    color: colors.vanilla, 
                                                                    backgroundColor: colors.darkGreen,
                                                                    borderRadius: "8px",
                                                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.goldenrod }, 
                                                                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: colors.gold }, 
                                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: colors.gold },
                                                                    '& .MuiSvgIcon-root': { color: colors.vanilla }
                                                                }}
                                                            >
                                                                <MenuItem value="" sx={{ bgcolor: colors.darkGreen, color: colors.vanilla }}>
                                                                    <em>None</em>
                                                                </MenuItem>
                                                                {recepts.map((item) => (
                                                                    <MenuItem key={item.id} value={item.data.uid} sx={{ bgcolor: colors.darkGreen, color: colors.vanilla, '&:hover': { bgcolor: colors.calPolyGreen } }}>
                                                                        {item.data.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>

                                                    {/* From Date */}
                                                    <div className="col-sm-3 mb-3 mb-sm-0">
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            label="From Date"
                                                            type="date"
                                                            value={fromDate}
                                                            onChange={handleFromDate}
                                                            InputLabelProps={{ shrink: true, style: { color: colors.vanilla } }}
                                                            InputProps={{ style: { color: colors.vanilla } }}
                                                            sx={{ 
                                                                "& .MuiOutlinedInput-root": { 
                                                                    borderRadius: "8px",
                                                                    backgroundColor: colors.darkGreen,
                                                                    "& fieldset": { borderColor: colors.goldenrod },
                                                                    "&:hover fieldset": { borderColor: colors.gold },
                                                                    "&.Mui-focused fieldset": { borderColor: colors.gold }
                                                                } 
                                                            }}
                                                        />
                                                    </div>

                                                    {/* To Date */}
                                                    <div className="col-sm-3 mb-3 mb-sm-0">
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            label="To Date"
                                                            type="date"
                                                            value={toDate}
                                                            onChange={handleToDate}
                                                            InputLabelProps={{ shrink: true, style: { color: colors.vanilla } }}
                                                            InputProps={{ style: { color: colors.vanilla } }}
                                                            sx={{ 
                                                                "& .MuiOutlinedInput-root": { 
                                                                    borderRadius: "8px",
                                                                    backgroundColor: colors.darkGreen,
                                                                    "& fieldset": { borderColor: colors.goldenrod },
                                                                    "&:hover fieldset": { borderColor: colors.gold },
                                                                    "&.Mui-focused fieldset": { borderColor: colors.gold }
                                                                } 
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Button */}
                                                    <div className="col-sm-3">
                                                        <Button
                                                            fullWidth
                                                            variant="contained"
                                                            disabled={loading}
                                                            onClick={getReport}
                                                            sx={{ 
                                                                bgcolor: colors.goldenrod, 
                                                                color: colors.darkGreen, 
                                                                fontWeight: 700, 
                                                                textTransform: "none", 
                                                                borderRadius: "8px",
                                                                height: "40px",
                                                                '&:hover': { bgcolor: colors.gold } 
                                                            }}
                                                        >
                                                            {loading ? "Loading..." : "Get Report"}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardContent>
                                    </Card>

                                    <Card className="print-area" ref={printRef} sx={{ borderRadius: 3, border: `1px solid ${colors.goldenrod}`, bgcolor: colors.calPolyGreen, color: colors.vanilla, boxShadow: "0 4px 20px 0 rgba(0,0,0,0.3)" }}>
                                        <CardContent sx={{ p: 3 }}>

                                            {/* HEADER */}
                                            <div className="container-fluid p-0 mb-3">
                                                <div className="row align-items-center text-center">
                                                    <div className="col-sm-4 mb-2 mb-sm-0">
                                                        <Typography variant="subtitle2" sx={{ color: colors.vanilla }}>
                                                            From Date : {fromDate ? moment(fromDate).format("DD/MM/YYYY") : "—"}
                                                        </Typography>
                                                    </div>

                                                    <div className="col-sm-4 mb-2 mb-sm-0">
                                                        <Typography variant="h6" fontWeight="bold" textTransform="uppercase" sx={{ color: colors.gold }}>
                                                            {username || "Receptionist"} Report
                                                        </Typography>
                                                    </div>

                                                    <div className="col-sm-4">
                                                        <Typography variant="subtitle2" sx={{ color: colors.vanilla }}>
                                                            To Date : {toDate ? moment(toDate).format("DD/MM/YYYY") : "—"}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>

                                            <Divider sx={{ mb: 3, borderColor: colors.goldenrod, opacity: 0.4 }} />

                                            {/* BOOKING REPORT */}
                                            <Typography
                                                variant="subtitle1"
                                                sx={{ bgcolor: colors.darkGreen, color: colors.gold, p: 1.5, fontWeight: 700, borderRadius: "8px 8px 0 0", borderTop: `1px solid ${colors.goldenrod}`, borderX: `1px solid ${colors.goldenrod}` }}
                                            >
                                                Booking Report
                                            </Typography>

                                            <TableContainer component={Paper} elevation={0} sx={{ borderRadius: "0 0 8px 8px", border: `1px solid ${colors.goldenrod}`, backgroundColor: "transparent", mb: 4 }}>
                                                <Table size="small">
                                                    <TableHead sx={{ bgcolor: colors.darkGreen }}>
                                                        <TableRow>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Sr</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Customer</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Check-in</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Check-out</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Days</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Rooms</TableCell>
                                                            <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Room</TableCell>
                                                            <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Extra</TableCell>
                                                            <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Food</TableCell>
                                                            <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Total</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Payments</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Status</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {bookingData.length === 0 && (
                                                            <TableRow>
                                                                <TableCell colSpan={12} align="center" sx={{ py: 4, color: colors.vanilla, opacity: 0.7 }}>
                                                                    No booking records found
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                        {bookingData.map((item, index) => (
                                                            <TableRow key={index} hover sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' } }}>
                                                                <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{index + 1}</TableCell>
                                                                <TableCell sx={{ color: colors.gold, fontWeight: 600, textTransform: "capitalize", borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                                    {item.booking.customers.custname}
                                                                </TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, opacity: 0.9, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                                    {moment(item.checkindate).format("DD/MM/YYYY")}
                                                                </TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, opacity: 0.9, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                                    {moment(item.checkoutdate).format("DD/MM/YYYY")}
                                                                </TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.todayDays}</TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                                    {item.booking.rooms.map((r, i) => (
                                                                        <Typography key={i} variant="caption" display="block" sx={{ color: colors.vanilla }}>
                                                                            {r.roomno} ({r.discount}%)
                                                                        </Typography>
                                                                    ))}
                                                                </TableCell>
                                                                <TableCell align="right" sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.roomamount}</TableCell>
                                                                <TableCell align="right" sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.serviceamount}</TableCell>
                                                                <TableCell align="right" sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.foodamount}</TableCell>
                                                                <TableCell align="right" sx={{ color: colors.gold, fontWeight: 700, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.totalamount}</TableCell>

                                                                <TableCell sx={{ borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                                    {item.paymentHistory.length > 0 ? (
                                                                        item.paymentHistory.map((p, i) => (
                                                                            <Typography key={i} variant="caption" display="block" sx={{ color: colors.vanilla }}>
                                                                                {p.paymode1} : {p.data.amount1}
                                                                            </Typography>
                                                                        ))
                                                                    ) : (
                                                                        <Typography color="error" sx={{ color: '#f87171' }}>Pending</Typography>
                                                                    )}
                                                                </TableCell>

                                                                <TableCell sx={{ borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                                    {item.booking.checkindate !== moment().format("YYYY-MM-DD") && (
                                                                        <Typography sx={{ color: '#4ade80', fontSize: '0.75rem', fontWeight: 600 }}>
                                                                            Continued
                                                                        </Typography>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                            {/* COLLECTION REPORT */}
                                            <Typography
                                                variant="subtitle1"
                                                sx={{ bgcolor: colors.darkGreen, color: colors.gold, p: 1.5, fontWeight: 700, borderRadius: "8px 8px 0 0", borderTop: `1px solid ${colors.goldenrod}`, borderX: `1px solid ${colors.goldenrod}` }}
                                            >
                                                Collection Report
                                            </Typography>

                                            <TableContainer component={Paper} elevation={0} sx={{ borderRadius: "0 0 8px 8px", border: `1px solid ${colors.goldenrod}`, backgroundColor: "transparent", mb: 3 }}>
                                                <Table size="small">
                                                    <TableHead sx={{ bgcolor: colors.darkGreen }}>
                                                        <TableRow>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Customer</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Room</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Check-in</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Check-out</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Paymode 1</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Amt 1</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Paymode 2</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Amt 2</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Date</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {payhistory.length === 0 && (
                                                            <TableRow>
                                                                <TableCell colSpan={9} align="center" sx={{ py: 4, color: colors.vanilla, opacity: 0.7 }}>
                                                                    No collection records found
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                        {payhistory.map((item, index) => (
                                                            <TableRow key={index} hover sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' } }}>
                                                                <TableCell sx={{ color: colors.gold, fontWeight: 600, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.bookingData.custName}</TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>
                                                                    {item.bookingData.rooms.map((r, i) => (
                                                                        <Typography key={i} variant="caption" display="block" sx={{ color: colors.vanilla }}>
                                                                            {r.roomno}
                                                                        </Typography>
                                                                    ))}
                                                                </TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, opacity: 0.9, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{moment(item.bookingData.checkinDate).format("DD-MM-YYYY")}</TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, opacity: 0.9, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{moment(item.bookingData.checkoutDate).format("DD-MM-YYYY")}</TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.paymode1}</TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.data.amount1}</TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.paymode2}</TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.data.amount2}</TableCell>
                                                                <TableCell sx={{ color: colors.vanilla, opacity: 0.9, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.createdat}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                            {/* PAYMODE SUMMARY */}
                                            <div className="container-fluid p-0 mb-3">
                                                <div className="row g-2">
                                                    {paymodes.map(
                                                        (p, i) =>
                                                            p.totalamount > 0 && (
                                                                <div className="col-sm-2" key={i}>
                                                                    <Paper elevation={0} sx={{ p: 1.5, textAlign: "center", bgcolor: colors.darkGreen, border: `1px solid ${colors.goldenrod}`, borderRadius: 2 }}>
                                                                        <Typography variant="caption" sx={{ color: colors.vanilla, opacity: 0.8 }}>{p.paymode}</Typography>
                                                                        <Typography fontWeight="bold" sx={{ color: colors.gold }}>{p.totalamount}</Typography>
                                                                    </Paper>
                                                                </div>
                                                            )
                                                    )}
                                                </div>
                                            </div>

                                            {/* TOTAL */}
                                            <Paper elevation={0} sx={{ mt: 3, p: 2, textAlign: "center", bgcolor: colors.darkGreen, border: `1px solid ${colors.goldenrod}`, borderRadius: 2 }}>
                                                <Typography variant="h6" fontWeight={700} sx={{ color: colors.gold }}>
                                                    Total Collection : ₹ {total} /-
                                                </Typography>
                                            </Paper>

                                        </CardContent>
                                    </Card>

                                    <div className="text-center mt-3 no-print">
                                        <Button 
                                            variant="contained" 
                                            onClick={handlePrint}
                                            sx={{ 
                                                bgcolor: colors.goldenrod, 
                                                color: colors.darkGreen, 
                                                fontWeight: 700, 
                                                textTransform: "none", 
                                                borderRadius: "8px",
                                                px: 4,
                                                py: 1.2,
                                                '&:hover': { bgcolor: colors.gold } 
                                            }}
                                        >
                                            Print Report
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </Box>
        </Box>
    );
}

export default Receptionistreport;